import { create } from 'zustand';

const API = `${process.env.REACT_APP_BACKEND_URL}/api/india`;

export const useSmartMoneyStore = create((set, get) => ({
  items: [],
  total: 0,
  page: 1,
  pageSize: 50,
  loading: false,
  error: null,
  holderType: 'fii',
  direction: '',
  minChange: 0.5,

  setHolderType: (t) => { set({ holderType: t, page: 1 }); get().fetch(1); },
  setDirection: (d) => { set({ direction: d, page: 1 }); get().fetch(1); },
  setMinChange: (v) => set({ minChange: v }),

  fetch: async (pg) => {
    const { holderType, direction, minChange, pageSize } = get();
    const p = pg || get().page;
    set({ loading: true, error: null, page: p });
    try {
      const params = new URLSearchParams({
        holder_type: holderType,
        min_change: minChange,
        page: p,
        page_size: pageSize,
      });
      if (direction) params.set('direction', direction);
      const res = await fetch(`${API}/smart-money?${params}`);
      if (!res.ok) throw new Error(`HTTP ${res.status}`);
      const data = await res.json();
      set({ items: data.items || [], total: data.total || 0, loading: false });
    } catch (err) {
      set({ loading: false, error: err.message });
    }
  },
}));
